
import { z } from "zod";

export const ItelDamageExtentValues = ["LESS", "MORE"] as const;
export const ItelDamageExtentSchema = z.enum(ItelDamageExtentValues);
export const ItelDamageExtent = ItelDamageExtentSchema.enum;
export type ItelDamageExtent = (typeof ItelDamageExtentValues)[number];
